export const CREATE_SESSION = 'CREATE_SESSION'
export const READ_DEVICES = 'READ_DEVICES'
export const DELETE_SESSION = 'DELETE_SESSION'
export const READ_POSITIONS = 'READ_POSITIONS'
export const UPDATE_AWARDED_DEVICES = 'UPDATE_AWARDED_DEVICES'
export const READ_GEOFENCES = 'READ_GEOFENCES'
export const READ_COMPETITION_TRACKPOINTS = 'READ_COMPETITION_TRACKPOINTS'
export const READ_CLASSIFICATION_GPX_FILE = 'READ_CLASSIFICATION_GPX_FILE'
export const READ_COMPETITION = 'READ_COMPETITION'
export const READ_COMPETITION_CLASSIFICATIONS =
    'READ_COMPETITION_CLASSIFICATIONS'
export const READ_LOCATION = 'READ_LOCATION'
export const READ_APP_STATUS = 'READ_APP_STATUS'
export const READ_PLAYERS = 'READ_PLAYERS'
export const READ_SESSION = 'READ_SESSION'
export const READ_SUMMARY_DEVICE = 'READ_SUMMARY_DEVICE'
export const READ_ROUTE = 'READ_ROUTE'
export const BOOTSTRAP_MAP = 'BOOTSTRAP_MAP'
export const READ_GEOJSON_REPLAY = 'READ_GEOJSON_REPLAY'
export const READ_EVENT_TIMES_DATA = 'READ_EVENT_TIMES_DATA'
